export const wToKw = (w: number): number => Math.round(w / 1000);
